export function getSeedkitBaseUrlFromEnv(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  const raw = env.SEEDKIT_BASE_URL || env.VITE_SEEDKIT_BASE_URL || '';
  return String(raw).replace(/\/$/, '');
}
